import { motion } from "framer-motion";
import { ArrowRight, Plane, Building2, Users, Compass } from "lucide-react";
import { Link } from "react-router-dom";
import serviceAirport from "@/assets/service-airport.jpg";
import serviceHotel from "@/assets/service-hotel.jpg";
import serviceGroup from "@/assets/service-group.jpg";

const services = [
  { title: "Airport Transfers", description: "Door-to-door service from PUJ, SDQ, STI, and all Dominican airports to your hotel, resort, or Airbnb.", image: serviceAirport, icon: Plane, link: "/transfers", linkText: "Explore Airport Transfers" },
  { title: "Hotel to Hotel", description: "Moving between resorts? We calculate the best route and offer fixed pricing for all inter-hotel transfers.", image: serviceHotel, icon: Building2, link: "/transfers", linkText: "Explore Hotel Transfers" },
  { title: "Group Transfers", description: "Traveling with a large group? Our vans and minibuses accommodate up to 15+ passengers comfortably.", image: serviceGroup, icon: Users, link: "/fleet", linkText: "View Our Fleet" },
  { title: "Tours & Excursions", description: "Discover the best of Dominican Republic with our curated tours — from island hopping to city adventures.", image: "https://images.unsplash.com/photo-1590523741831-ab7e8b8f9c7f?w=400&auto=format&fit=crop&q=75", icon: Compass, link: "/tours", linkText: "Discover Tours & Excursions" },
];

const ServicesSection = () => {
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <p className="text-primary font-semibold text-sm uppercase tracking-widest mb-2">
            Our Services
          </p>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground">
            Tours & Transfer Solutions
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group bg-white rounded-lg overflow-hidden border border-border hover:shadow-md transition-all duration-300"
            >
              <div className="relative overflow-hidden h-44">
                <img
                  src={service.image}
                  alt={service.title}
                  width={400}
                  height={248}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 w-10 h-10 rounded-lg bg-primary flex items-center justify-center">
                  <service.icon className="w-5 h-5 text-primary-foreground" />
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-display text-base font-bold text-foreground mb-2">
                  {service.title}
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed mb-4">
                  {service.description}
                </p>
                <Link
                  to={service.link}
                  className="inline-flex items-center gap-2 text-primary font-semibold text-sm group-hover:gap-3 transition-all"
                >
                  {service.linkText} <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
